import { View } from 'react-native';
import { KeyboardStickyView } from 'react-native-keyboard-controller';
import { useSafeAreaInsets } from 'react-native-safe-area-context';

export default function ModalKeyboardStickyView({
  children,
}: {
  children: React.ReactNode;
}) {
  const { bottom } = useSafeAreaInsets();

  return (
    <KeyboardStickyView offset={{ closed: 0, opened: bottom }}>
      <View style={{ paddingBottom: bottom }}>{children}</View>
    </KeyboardStickyView>
  );
}
